import { getTranslationObj } from "../utils/translation";

const translation = getTranslationObj()

export default translation;
